module.exports = __webpack_public_path__ + "img/ilus_analitica.34a05525.svg";